// Keyboard-hint helpers: Mac shows ⌘K, everything else (Windows, Linux, ChromeOS) Ctrl K.

function detectMac(): boolean {
  if (typeof navigator === 'undefined') return false;
  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  return /mac|iphone|ipad|ipod/i.test(uaData?.platform ?? navigator.userAgent);
}

export const IS_MAC = detectMac();

export const SHORTCUT_LABEL = IS_MAC ? '⌘K' : 'Ctrl K';
